import { FormBase } from 'core/components';

export default class PumpEditForm extends FormBase {
    constructor(hooks) {
        super(hooks);
    }

    setup() {
        return {
            fields: [
                {
                    name: 'productId',
                    label: 'PUMPS.EDIT.PRODUCT_LABEL',
                    placeholder: 'PUMPS.EDIT.PRODUCT_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: 'serialNumber',
                    label: 'PUMPS.EDIT.SERIAL_NUMBER_LABEL',
                    placeholder: 'PUMPS.EDIT.SERIAL_NUMBER_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: 'dateSent',
                    label: 'PUMPS.EDIT.DATE_SENT_LABEL',
                    placeholder: 'PUMPS.EDIT.DATE_SENT_PLACEHOLDER'
                },
                {
                    name: 'dateReturnRequested',
                    label: 'PUMPS.EDIT.DATE_RETURN_REQUESTED_LABEL',
                    placeholder: 'PUMPS.EDIT.DATE_RETURN_REQUESTED_PLACEHOLDER'
                },
                {
                    name: 'dateReturned',
                    label: 'PUMPS.EDIT.DATE_RETURNED_LABEL',
                    placeholder: 'PUMPS.EDIT.DATE_RETURNED_PLACEHOLDER'
                },
                {
                    name: 'pumpStatusId',
                    label: 'PUMPS.EDIT.STATUS_LABEL',
                    placeholder: 'PUMPS.EDIT.STATUS_PLACEHOLDER',
                    rules: 'string|required'
                },
                {
                    name: 'stickered',
                    type: 'bool',
                    value: false
                },
                {
                    name: 'notes',
                    label: 'PUMPS.EDIT.NOTES_LABEL',
                    placeholder: 'PUMPS.EDIT.NOTES_PLACEHOLDER',
                    rules: 'string'
                },
                {
                    name: 'branch',
                    label: 'PUMPS.EDIT.BRANCH_LABEL',
                    rules: 'string|required',
                    value: 'Lakewood'
                },
            ],
        };
    }
}
